import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext({ site_name: "Lomar Properties" });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: "Lomar Properties",
    hero_title: "Achetez, louez ou rentabilisez votre bien.",
    hero_subtitle: "",
    commission_rate: 0.1,
  });

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch { /* keep defaults */ }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
